/**
 * Reads a cookie by name. Works for cookies set at the root
 * domain level (e.g. .sparta.aero shared across all subdomains).
 */
export function getGlobalCookie(name) {
  const match = document.cookie.match(
    new RegExp('(?:^|;\\s*)' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Removes a cookie at the root domain level.
 */
export function deleteGlobalCookie(name) {
  const domain = window.location.hostname.split('.').slice(-2).join('.');
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain};`;
}

/**
 * Sets a cookie at the root domain level.
 */
export function setGlobalCookie(name, value, days = 1) {
  const domain = window.location.hostname.split('.').slice(-2).join('.');
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; domain=.${domain};`;
}
